import { Injectable } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import {ColorI} from "../../../../../builder-v2.interface";
import {BuilderSectionsInteractionService} from "../../../../../builder-sections-interaction.service";
import {Utils} from "../../../../../../shared/utils/utils";

@Injectable({ providedIn: 'root' })
export class HeroSectionHelper {
  constructor(private _builderInteractionsService: BuilderSectionsInteractionService) {}

  getTheme(): string {
    return this._builderInteractionsService.activeTheme.value.toLowerCase();
  }

  getInitialStyles(): any {
    const colorOption: ColorI = this._builderInteractionsService.activeColor.value;
    const hasDarkBg = Utils.colorIsDarkSimple(colorOption.primaryColor);
    return {
      '--accentColor': colorOption.primaryColor,
      '--secondaryColor': colorOption.secondaryColor,
      '--accentColorShade': `${colorOption.primaryColor}0A`,
      '--accentColorShade2': `${colorOption.primaryColor}1A`,
      '--textColor': hasDarkBg ? '#FFFFFF' : '#000000',
      '--fontFamily': this._builderInteractionsService.activeFont.value,
    };
  }

  getMenuPages(): any {
    return this._builderInteractionsService.secondaryPages.value;
  }

  isMobile(): boolean {
    return window.innerWidth <= 991;
  }

  isEcommerceType(generatedTexts: any): boolean {
    return generatedTexts?.website_type !== 'basic';
  }

  createFadeArray(length: number): boolean[] {
    return new Array(length).fill(false);
  }

  toggleMenu(openMenu: boolean): boolean {
    document.getElementById("menu")?.classList.toggle("open");
    return !openMenu;
  }

  fadeInElements(array: boolean[], cdr: ChangeDetectorRef, callback?: () => void): void {
    array.forEach((_, index) => {
      setTimeout(() => {
        array[index] = true;
        cdr.markForCheck();

        if (index === array.length - 1 && callback) callback();
      }, index * 200);
    });
  }
}
